import React from "react";

// What an AI verdict was based on: how much text it saw, and whether its answer cited evidence.
// Shared by the item page's model verdicts and second opinions.

// Confidence is never shown as 100% (core/ai_quality caps new answers at 99%; older rows are capped here).
export const pct = (c) => (c == null ? "—" : `${Math.round(Math.min(Number(c), 0.99) * 100)}%`);

// "saw 12,000 of 204,947 characters (most relevant parts)" / "saw the whole text (3,210 characters)".
export function InputSeen({ v, testid }) {
  if (v.input_chars_total == null) return null;
  const n = (x) => Number(x).toLocaleString("en");
  return (
    <span data-testid={testid}>
      {v.input_truncated
        ? <> · saw {n(v.input_chars_sent)} of {n(v.input_chars_total)} characters <strong>(truncated: most relevant parts)</strong></>
        : <> · saw the whole text ({n(v.input_chars_total)} characters)</>}
    </span>);
}

export function LowQuality({ v, testid }) {
  if (!v.low_quality) return null;
  return (
    <span className="hs-badge hs-badge-warning" style={{ marginLeft: 6 }} data-testid={testid}
          title={`Benign without citing any evidence while our rules flagged the text; confidence capped at 60% (the model said ${pct(v.confidence_raw)})`}>
      low-quality</span>);
}
